/**
 * From materialUI "Integration with 3rd party input libraries":
 *   https://material-ui.com/components/text-fields/#integration-with-3rd-party-input-libraries
 *
 * MUI v5's `inputComponent` slot requires the component to accept a ref via
 * React.forwardRef; otherwise you get the "Invalid prop `inputComponent`
 * supplied to ForwardRef(InputBase)" warning.
 */
import React from 'react';
import NumberFormat from 'react-number-format';

interface NumberFormatCustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

export const NumberFormatCustom = React.forwardRef<HTMLInputElement, NumberFormatCustomProps>(
    function NumberFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={ref as any}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator
                isNumericString
            />
        );
    }
);
